import api from '@/helpers/api';

export default {
  fetchInvoices({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/invoices`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INVOICES', response.data);
        }
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        // console.log(error.response);
      });
  },
  fetchInvoice({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/invoices/${payload.invoice_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_INVOICE', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchPublicInvoice({ commit }, payload) {
    api('GET', `/merchants/${payload.merchant_id}/invoices/${payload.invoice_id}/public`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_PUBLIC_INVOICE', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  createInvoice({ commit }, payload) {
    commit('SET_SUCCESS_CREATE', false);
    api('POST', `/merchants/${payload.merchant_id}/invoices`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUCCESS_CREATE', response.data.id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchNextInvoiceNumber({ commit }, merchantId) {
    api('GET', `/merchants/${merchantId}/invoices/next-invoice-number`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_NEXT_INVOICE_NUMBER', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  fetchTotalRevenue({ commit }, merchantId) {
    api('GET', `/merchants/${merchantId}/invoices/revenue`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_TOTAL_REVENUE', response.data);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  deleteInvoice({ commit }, payload) {
    commit('SET_SUCCESS_DELETE', false);
    api('DELETE', `/merchants/${payload.merchant_id}/invoices/${payload.invoice_id}`)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_SUCCESS_DELETE', payload.invoice_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  invoiceCheckout({ commit }, payload) {
    commit('CHECKOUT_SUCCESSFULLY_DONE', false);
    api('POST', `/merchants/${payload.merchant_id}/invoices/${payload.invoice_id}/payments/checkout`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('CHECKOUT_SUCCESSFULLY_DONE', payload.invoice_id);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  calculateTaxjarTax({ commit }, payload) {
    commit('SET_CALCULATED_TAX', false);
    api('POST', `/merchants/${payload.merchant_id}/invoices/${payload.invoice_id}/taxjar`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CALCULATED_TAX', response.data.amount_to_collect);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
  calculateTax({ commit }, payload) {
    commit('SET_CALCULATED_TAX', false);
    api('POST', `/merchants/${payload.merchant_id}/invoices/${payload.invoice_id}/taxes`, payload.data)
      .then((response) => {
        if (response.status === 200) {
          commit('SET_CALCULATED_TAX', response.data.tax);
        }
      })
      .catch((error) => {
        commit('API_ERROR', error.response);
      });
  },
};
